class Bus {
    constructor(attachTo) {
        // If specified, the bus can attach the on/off/emit functions to the given instance, such that one may - on the
        // specified instance - avoid preceeding calls to the below methods with '.bus'
        if (attachTo) {
            attachTo.on = this.on.bind(this);
            attachTo.off = this.off.bind(this);
            attachTo.emit = this.emit.bind(this);
        }
        
        this.events = { };
    }

    /**
     * Set event listener.
     *
     * @param event
     * @param callback
     */
    on(event, callback) {
        if (this.destroyed || typeof callback !== 'function') {
            throw new TypeError('Bus.on expects the callback to be of type "function"');
        }

        if (typeof this.events[event] !== 'object') {
            this.events[event] = [ ];
        }

        this.events[event].push(callback);
    }

    /**
     * Remove an event listener.
     *
     * @param event
     * @param callback - If not passed, all events of given type will be removed
     */
    off(event, callback = null) {
        // No need to continue in this case
        if (this.destroyed || typeof this.events[event] !== 'object') {
            return;
        }

        if (callback) {
            let index;

            // In case the same callback was passed multiple times
            while ((index = this.events[event].indexOf(callback)) !== -1) {
                this.events[event].splice(index, 1);
            }
        } else {
            delete this.events[event];
        }
    }

    /**
     * Emit an event of the given type, passing the given data to the callback.
     *
     * @param event
     * @param data
     */
    emit(event, ...data) {
        if (this.destroyed || typeof this.events[event] !== 'object') {
            return;
        }

        let events = this.events[event],
            length = events.length,
            index;

        for (index = 0; index < length; ++index) {
            events[index].apply(null, data);
        }
    }

    destroy() {
        this.events = null;
        this.destroyed = true;
    }
}

export default Bus;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/tools/bus.js